import { client } from '../client';

interface Payload {
  current_email: string;
}

export interface RequestEmailUpdateResponse {
  message: string;
  requires_manual_verification?: boolean;
  last_four_digits_of_phone?: string;
}

export const requestEmailUpdate = async (payload: Payload): Promise<RequestEmailUpdateResponse> => {
  const { data } = await client.post<RequestEmailUpdateResponse>(`/auth/email_update/request`, payload);

  return data;
};
